import { NgxLoadingButtonsModule } from 'ngx-loading-buttons';

import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatRippleModule } from '@angular/material/core';
import { MatDialogModule } from '@angular/material/dialog';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatSelectModule } from '@angular/material/select';
import { MatSortModule } from '@angular/material/sort';
import { MatTableModule } from '@angular/material/table';
import { MatTooltipModule } from '@angular/material/tooltip';

import { SnCommonModule } from '@lib/common';
import { SnFormModule } from '@lib/form';
import { SnMapModule } from '@lib/geo/map';
import { SnActionsModule } from '@lib/ui/actions';
import { SnButtonModule } from '@lib/ui/button';
import { SnDataListModule } from '@lib/ui/data-list';
import { SnIconModule } from '@lib/ui/icon';
import { SnListModule } from '@lib/ui/list';
import { SnSearchbarModule } from '@lib/ui/searchbar';

import { TranslationModule } from "../../../translation/src/lib/translation.module";
import { AssociateUserDialogComponent } from './components/associate-user-dialog/associate-user-dialog.component';
import { BriefcamCaseSearchDialogComponent } from './components/briefcam-case-search-dialog/briefcam-case-search-dialog.component';
import { IncidentCaseSearchDialogComponent } from './components/incident-case-search-dialog/incident-case-search-dialog.component';
import { IncidentCaseSearchTableComponent } from './components/incident-case-search-table/incident-case-search-table.component';
import { IncidentDetailsComponent } from './components/incident-details';
import { IncidentMediaDialogComponent } from './components/incident-media-dialog';
import { IncidentMediaListComponent } from './components/incident-media-list';
import { IncidentMediaListItemComponent } from './components/incident-media-list-item';
import { IncidentTableComponent } from './components/incident-table';
import { IncidentMediaContainer } from './containers';

@NgModule({
  imports: [
    // Angular
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    // Material
    MatCardModule,
    MatSelectModule,
    MatSortModule,
    MatTableModule,
    MatProgressSpinnerModule,
    MatTooltipModule,
    MatDialogModule,
    NgxLoadingButtonsModule,
    MatButtonModule,
    MatRippleModule,
    // Libs
    SnCommonModule,
    SnFormModule,
    SnMapModule,
    SnIconModule,
    SnListModule,
    SnDataListModule,
    SnActionsModule,
    SnButtonModule,
    SnSearchbarModule,
    TranslationModule
],
  exports: [
    IncidentTableComponent,
    IncidentDetailsComponent,
    IncidentMediaContainer,
    IncidentMediaListComponent,
    IncidentMediaListItemComponent,
    IncidentMediaDialogComponent,
    AssociateUserDialogComponent,
  ],
  declarations: [
    IncidentTableComponent,
    IncidentDetailsComponent,
    IncidentMediaContainer,
    IncidentMediaListComponent,
    IncidentMediaListItemComponent,
    IncidentMediaDialogComponent,
    AssociateUserDialogComponent,
    IncidentCaseSearchDialogComponent,
    BriefcamCaseSearchDialogComponent,
    IncidentCaseSearchTableComponent,
  ],
})
export class SnIncidentsModule {}
